import React, {useEffect, useState} from 'react';
import {
  Container,
  Icon,
  ModalContainer,
  InputContainer,
  IconDev,
  Content,
  Input,
  InputLabel,
  DefaultUrls,
  UrlButton,
  UrlText,
  TermCheckButton,
  TermCheckIcon,
  Label,
  ClearInputButton,
  ClearInputIcon,
  InputContainerColumn,
} from './styles';
import Modal from 'react-native-modal';
import {barataoApis, setApiUrl} from '../../../services/api';
import {useAuth} from '../../../context/auth';
import {Button} from '../../Interface/Forms/Buttons/Button';
import Toast from 'react-native-toast-message';

import {PanGestureHandler} from 'react-native-gesture-handler';
import Animated, {
  useAnimatedGestureHandler,
  useSharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated';
import {useLocalization} from '../../../context/localization';
import {useGlobal} from '../../../context/global';
import AsyncStorage from '@react-native-async-storage/async-storage';

export function Dev() {
  const [showModal, setShowModal] = useState(false);
  const {user} = useAuth();
  const [socket, setSocket] = useState('');

  const {getCurrentCity} = useLocalization();
  const {fetchConfigIndiqueGanhe, prodStripe, setProdStripe} = useGlobal();

  const translateX = useSharedValue(0);
  const translateY = useSharedValue(0);

  const onGestureEvent = useAnimatedGestureHandler({
    onStart: (_, ctx: any) => {
      ctx.startX = translateX.value;
      ctx.startY = translateY.value;
    },
    onActive: (event, ctx) => {
      translateX.value = ctx.startX + event.translationX;
      translateY.value = ctx.startY + event.translationY;
    },
  });

  const animatedStyle = useAnimatedStyle(() => ({
    //@ts-ignore
    transform: [{translateX: translateX.value}, {translateY: translateY.value}],
  }));

  function showDevAlert() {
    setShowModal(true);
  }

  function handleDimissLoginModal() {
    setShowModal(false);
  }

  async function fetchDevUrlFromAsyncStorage() {
    try {
      const devUrl = await AsyncStorage.getItem('dev_url');

      if (devUrl !== null && devUrl.length > 1) {
        setSocket(devUrl);
        handleAddSocket(devUrl);
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function setDevUrlInAsyncStorage(url: string) {
    try {
      await AsyncStorage.setItem('dev_url', url);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    fetchDevUrlFromAsyncStorage();
  }, []);

  function handleAddSocket(socketUrl?: string) {
    const url = socketUrl !== undefined ? socketUrl : socket;
    setApiUrl(url);

    if (user.token) {
      for (const instance of barataoApis) {
        instance.defaults.headers.common.Authorization = `${user.token}`;
      }
    }

    setDevUrlInAsyncStorage(url);

    Toast.show({
      type: 'success',
      text1: 'Sucesso',
      text2: 'URL alterada',
    });

    getCurrentCity();
    fetchConfigIndiqueGanhe();
    handleDimissLoginModal();
  }

  return (
    <Container>
      <PanGestureHandler onGestureEvent={onGestureEvent}>
        <Animated.View style={animatedStyle}>
          <IconDev onPress={showDevAlert} activeOpacity={0.7}>
            <Icon name="code" />
          </IconDev>
        </Animated.View>
      </PanGestureHandler>

      <ModalContainer>
        <Modal
          isVisible={showModal}
          hasBackdrop
          onSwipeComplete={handleDimissLoginModal}
          onDismiss={handleDimissLoginModal}
          onBackdropPress={handleDimissLoginModal}
          style={{
            justifyContent: 'center',
            margin: 0,
          }}>
          <Content>
            <InputContainer>
              <InputContainerColumn>
                <InputLabel>URL da API:</InputLabel>
                <Input
                  placeholder="Ex: https://127.0.0.1:3000/api/v1"
                  value={socket}
                  onChangeText={e => setSocket(e)}
                  autoCapitalize="none"
                />
              </InputContainerColumn>
              <ClearInputButton activeOpacity={0.7} onPress={() => setSocket('')}>
                <ClearInputIcon name="x" />
              </ClearInputButton>
            </InputContainer>

            <DefaultUrls>
              <UrlButton
                activeOpacity={0.7}
                onPress={() =>
                  setSocket('https://baratao.herokuapp.com/api/v1')
                }>
                <UrlText>PROD</UrlText>
              </UrlButton>
              <UrlButton
                activeOpacity={0.7}
                onPress={() =>
                  setSocket('https://baratao-homologacao.herokuapp.com/api/v1')
                }>
                <UrlText>HMG 1</UrlText>
              </UrlButton>
              <UrlButton
                activeOpacity={0.7}
                onPress={() =>
                  setSocket(
                    'https://baratao2hmg-d4976ce3a8c0.herokuapp.com/api/v1',
                  )
                }>
                <UrlText>HMG 2</UrlText>
              </UrlButton>
              <UrlButton
                activeOpacity={0.7}
                onPress={() =>
                  setSocket(
                    'https://baratao3hmg-e06eeb0207c4.herokuapp.com/api/v1',
                  )
                }>
                <UrlText>HMG 3</UrlText>
              </UrlButton>
            </DefaultUrls>

            <TermCheckButton
              onPress={() => setProdStripe(!prodStripe)}
              activeOpacity={1}>
              <TermCheckIcon
                name={prodStripe ? 'check-square' : 'square-o'}
                checked={prodStripe}
              />
              <Label>Stripe:Prod</Label>
            </TermCheckButton>

            <Button
              enabled
              title="Confirmar"
              onPress={() => handleAddSocket()}
            />
          </Content>
        </Modal>
      </ModalContainer>
    </Container>
  );
}
